export enum GanttTaskStatus {
  None = 'none',
  Done = 'done',
  Active = 'active',
  Crit = 'crit',
  Milestone = 'milestone',
}

export enum GanttZoomLevel {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

// Explicit Unix units keep Mermaid's relative timeline semantics. Other date
// declarations use the shared calendar resolver, as does an omitted declaration.
export enum GanttDateFormat {
  IsoDate = 'YYYY-MM-DD',
  UnixSeconds = 'X',
  UnixMillis = 'x',
}

export interface GanttTask {
  id: string;
  label: string;
  status: GanttTaskStatus;
  startDate: Date;
  endDate: Date;
  dependsOn: string[];
  sectionIndex: number;
}

export interface GanttSection {
  index: number;
  label: string;
  taskIds: string[];
}

export interface ParsedGantt {
  title: string | null;
  dateFormat: string;
  excludesWeekends: boolean;
  sections: GanttSection[];
  tasks: GanttTask[];
  taskById: Map<string, GanttTask>;
}

export interface GanttDateRange {
  start: Date;
  end: Date;
}

export interface GanttGridLine {
  x: number;
  date: Date;
  label: string;
}

export interface GanttSectionRowLayout {
  kind: 'section';
  sectionIndex: number;
  label: string;
  y: number;
  height: number;
  isCollapsed: boolean;
}

export interface GanttTaskRowLayout {
  kind: 'task';
  taskId: string;
  sectionIndex: number;
  y: number;
  height: number;
}

export type GanttRowLayout = GanttSectionRowLayout | GanttTaskRowLayout;

export interface GanttTaskLayout {
  task: GanttTask;
  x: number;
  y: number;
  width: number;
  height: number;
  centerY: number;
  progressRatio: number;
}

export interface GanttLayout {
  dateRange: GanttDateRange;
  totalDays: number;
  pxPerDay: number;
  timelineWidth: number;
  rows: GanttRowLayout[];
  sectionRows: GanttSectionRowLayout[];
  taskRows: GanttTaskRowLayout[];
  taskLayouts: GanttTaskLayout[];
  taskLayoutById: Map<string, GanttTaskLayout>;
  gridLines: GanttGridLine[];
  todayX: number | null;
  chartHeight: number;
  labelColumnWidth: number;
  axisHeight: number;
  rowHeight: number;
}
